import { SchaleStudent } from "Models/Student";
import StudentMap from "Models/StudentMap";
import { useEffect, useMemo, useState } from "react";

export default function useSchaleStudents(callback?: (result: SchaleStudent[]) => void) {
	const [isReady, setIsReady] = useState(false);
	const [schaleStudent, setSchaleStudent] = useState<SchaleStudent[]>([]);
	const packagedData = useMemo(()=>{ return {
		BULLETS: [...new Set(schaleStudent.map(s=>s.BulletType))].sort(),
		ARMORS: [...new Set(schaleStudent.map(s=>s.ArmorType))].sort(),
		TACTICS: [...new Set(schaleStudent.map(s=>s.TacticRole))].sort(),
		SCHOOLS: [...new Set(schaleStudent.map(s=>s.School))].sort(),
		NAMES: [...new Set(schaleStudent.map(s=>s.Name))].sort(),
	}}, [schaleStudent]);

	async function initialize() {
		setSchaleStudent(await StudentMap.schaleTask);
		setIsReady(true);
		if (callback)
			callback(await StudentMap.schaleTask);
	}
	useEffect(() => {
		let ignore = false;
		if (!ignore && !isReady) {
			initialize();
		}
		return () => {
			ignore = true
		};
	}, [StudentMap.schaleTask]);

	return {
		isReady,
		schaleStudent, 
		...packagedData,
	};
}